var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BravadoProgressChartV2',{attrs:{"size":_vm.spinnerSize,"percent":25,"foreground-color":_vm.bgColor,"background-color":_vm.bgColor,"spinner":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }